import React from 'react'

function Underconstructionesl() {
    
  return (
    <div className="">

    <div className="container mb-5">
        <div className="logo" style={{textAlign:"center"}}>ELECTRONIC SHELF LABELING</div>
        
        <h1 style={{textAlign:"center"}}>Webpage Under Construction</h1>
        
        <div className="construction-icon" style={{textAlign:"center"}}>🔒</div>
        
        <p style={{fontFamily:"Poppins", textAlign:"justify"}}>We are excited to introduce our upcoming webpage dedicated to showcasing our cutting-edge Electronic Shelf Label (ESL) solutions, designed to meet the evolving needs of retail and industrial sectors. Our ESL systems offer a smarter, more efficient way to manage pricing, inventory, and promotions in real time. With seamless integration, dynamic updates, and sleek display options, our total ESL solutions ensure accuracy, enhance customer experience, and reduce operational costs — empowering businesses to stay competitive in a digital world.

</p>
        
        <div className="progress-bar">
            <div className="progress"></div>
        </div>
        
        <p className='mt-3' style={{fontFamily:"Poppins", textAlign:"justify"}}>Our team is developing a platform where you can explore our cutting-edge packaging machines designed to protect your business assets.</p>
        
        <div className="contact">
            For immediate assistance, please contact us at: <br/>
            <a href="marketing@zartecsolutions.com">marketing@zartecsolutions.com</a> 
        </div>
    </div>
    

    <style jsx>{`

        
        .container {
            max-width: 800px;
            background-color: white;
            padding: 40px;
            border-radius: 10px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
        }
        
        .logo {
            margin-bottom: 30px;
            font-size: 28px;
            font-weight: bold;
            color: #003366;
        }
        
        h1 {
            font-size: 36px;
            margin-bottom: 20px;
            color: #003366;
        }
        
        p {
            font-size: 18px;
            line-height: 1.6;
            margin-bottom: 30px;
        }
        
        .progress-bar {
            height: 20px;
            background-color: #e0e0e0;
            border-radius: 10px;
            overflow: hidden;
            position: relative;
        }
        
        .progress {
            width: 40%;
            height: 100%;
            background: linear-gradient(0deg, #003366, #0066cc);
            animation: pulse 2s infinite;
        }
        
        .construction-icon {
            font-size: 80px;
            margin: 20px 0;
            color: #003366;
        }
        
        .contact {
            margin-top: 30px;
            font-size: 16px;
        }
        
        .contact a {
            color: #0066cc;
            text-decoration: none;
        }
        
        .contact a:hover {
            text-decoration: underline;
        }
        
        @keyframes pulse {
            0% { opacity: 0.7; }
            50% { opacity: 1; }
            100% { opacity: 0.7; }
        }
        
        @media (max-width: 600px) {
            .container {
                padding: 20px;
            }
            
            h1 {
                font-size: 28px;
            }
            
            p {
                font-size: 16px;
            }
        }
`}</style>
    </div>
  )
}

export default Underconstructionesl
